import { Modal, Input, Button, Select } from 'antd'
import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@ant-design/icons'
import {
	fetchItemsGroups,
	fetchUoMGroups,
	fetchItemsServicesGroups,
	fetchItemsModalServices,
} from '@utils/fetchData'
import { useQuery } from '@tanstack/react-query'
import SuccessModal from './SuccessModal'
import ErrorModal from './ErrorModal'
import { http } from '@services/http'
import { formatNumberWithSpaces, removeSpaces } from '@utils/numberWithSpaces'
const ViewServiceItemsModal = ({
	visible,
	data,
	onClose,
	onClick,
	finish = false,
}) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const [ugpName, setUgpName] = useState('')
	const [itemName, setItemName] = useState('')
	const [price, setPrice] = useState('')
	const [currency, setCurrency] = useState('')
	const [itmsGrp, setItmsGrp] = useState('')
	const [timer, setTimer] = useState('')
	const [u_Number, setU_Number] = useState('')
	const [loading, setLoading] = useState(false)
	const [serviceGroup, setServiceGroup] = useState('')
	const [modalService, setModalService] = useState('')

	useEffect(() => {
		if (data) {
			setItemName(data.itemName)
			setUgpName(data.ugpEntry ?? '')
			setPrice(parseFloat(data.price) ?? '')
			setCurrency(data.currency ?? '')
			setItmsGrp(data.itmsGrpNam ?? '')
			setTimer(data.u_Timer ?? '')
			setU_Number(data.u_Number ?? '')
			setModalService(data.u_Modal ?? '')
			setServiceGroup(data.u_ServiceGroup ?? '')
		}
	}, [data, visible])

	const {
		data: uomData = [],
		isLoading: uomLoading,
		refetch: uomRefetch,
	} = useQuery({
		queryKey: ['uoMEntry'],
		queryFn: fetchUoMGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: servicesGroupData = [], isLoading: servicesLoading } =
		useQuery({
			queryKey: ['servicesGrp'],
			queryFn: fetchItemsServicesGroups,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})
	const { data: modalServiceData = [] } = useQuery({
		queryKey: ['modalService'],
		queryFn: fetchItemsModalServices,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	if (!data) return null

	const resetForm = () => {
		setItemName('')
		setU_Number('')
		setTimer('')
		setUgpName('')
		setItmsGrp('')
		setPrice('')
		setCurrency('')
		setLoading(false)
		setServiceGroup('')
		setModalService('')
	}

	const patchData = async () => {
		setLoading(true)

		try {
			await http.patch(`api/items/${data.itemCode}`, {
				itemName: itemName,
				itemsGroupCode: data?.itmsGrpCod,
				uoMGroupEntry: ugpName,
				price: removeSpaces(price),
				currency: currency,
				u_Width: data?.u_Width,
				u_Height: data?.u_Height,
				u_Kvmetr: data?.u_Kvmetr,
				u_Timer: timer,
				u_Number: String(u_Number),
				u_DefaultCoefficient: data?.u_DefaultCoefficient,
				u_Modal: modalService,
				u_ServiceGroup: serviceGroup,
			})
			successRef.current.open(t('sucEdited'))
			resetForm()
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('infoItem')}
				</h1>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="70%"
			style={{ height: '80%' }}
		>
			<div className="w-full px-4 sm:px-5">
				<div className="w-full">
					<div className="mt-10 flex flex-col items-end gap-7 justify-between sm:flex-row">
						<div className="flex flex-col gap-3 w-full">
							<p className="font-nunito">{t('itemName')}</p>
							<Input
								type="text"
								value={itemName}
								className="flex h-10  w-full items-center justify-center "
								style={{ color: 'black' }}
								onChange={(e) => {
									setItemName(e.target.value)
								}}
							/>
						</div>

						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p className="font-nunito">{t('productGroup')}</p>
							<Input
								value={itmsGrp}
								className="flex h-10  w-[200px] items-center justify-center "
								style={{ color: 'black' }}
								onChange={(val) => {
									setItmsGrp(val)
								}}
								disabled
							/>
						</div>
						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p className="font-nunito">{t('currency')}</p>
							<Select
								value={currency}
								className="flex h-10  w-[150px] items-center justify-center "
								style={{ color: 'black' }}
								onChange={(val) => {
									setCurrency(val)
								}}
								options={[
									{
										label: 'UZS',
										value: 'UZS',
									},
									{
										label: 'USD',
										value: 'USD',
									},
								]}
							/>
						</div>
						<div className="flex flex-col gap-3">
							<p className="font-nunito">{`${t('price')} `}</p>
							<Input
								value={formatNumberWithSpaces(price)}
								className="flex h-10 w-full min-w-[120px] items-center justify-center"
								style={{ color: 'black' }}
								onChange={(e) => {
									setPrice(e.target.value)
								}}
							/>
						</div>
					</div>

					<div className="mt-10 flex flex-col items-end gap-7  justify-between sm:flex-row">
						<div className="flex flex-col gap-3">
							<p className="font-nunito">{`${t('timerItem')} `}</p>
							<Input
								value={timer}
								className="flex h-10 w-full  items-center justify-center border-[#D0D0D0]"
								style={{ color: 'black' }}
								onChange={(e) => {
									setTimer(e.target.value)
								}}
							/>
						</div>

						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p>{`${t('u_ServiceGroup')}`}</p>
							<Select
								type="text"
								value={serviceGroup}
								onChange={(val) => {
									setServiceGroup(val)
								}}
								className="flex h-10 w-[230px]  items-center justify-center border-[#D0D0D0]"
								options={servicesGroupData.map((item) => ({
									label: item.fldValue,
									value: item.descr,
								}))}
							/>
						</div>
						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p>{`${t('u_ModalService')}`}</p>
							<Select
								type="text"
								value={modalService}
								onChange={(val) => {
									setModalService(val)
								}}
								className="flex h-10 w-[150px]  items-center justify-center border-[#D0D0D0]"
								options={modalServiceData.map((item) => ({
									label: item.descr,
									value: item.fldValue,
								}))}
							/>
						</div>

						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p className="font-nunito">{`${t('unitMsr')}`}</p>
							<Select
								value={ugpName}
								className="flex h-10  w-full items-center justify-center "
								style={{ color: 'black' }}
								onChange={(val) => {
									setUgpName(val)
								}}
								options={uomData.map((item) => ({
									label: item.ugpName,
									value: item.ugpEntry,
								}))}
							/>
						</div>
						<div className="mt-4 flex flex-col gap-3 sm:mt-5 ">
							<p>{t('u_Number')}</p>
							<Input
								value={u_Number}
								type="text"
								style={{ color: 'black' }}
								onChange={(e) => {
									setU_Number(e.target.value)
								}}
								className="flex h-10 w-full  items-center justify-center border-[1px] border-[#D0D0D0]"
							/>
						</div>
					</div>
				</div>
				<div className="flex items-center gap-10 mt-14 justify-between">
					<Button
						onClick={() => {
							onClose()
						}}
						className="w-full bg-red-600 h-[35px] rounded-lg text-white"
					>
						{t('cancel')}
					</Button>
					<Button
						onClick={patchData}
						loading={loading}
						disabled={loading}
						className="w-full bg-[#0A4D68] h-[35px] rounded-lg text-white"
					>
						{t('save')}
					</Button>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => onClose()}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Modal>
	)
}

export default ViewServiceItemsModal
